import { render } from "./UserCell.vue?vue&type=template&id=65f790f0"
import script from "./UserCell.vue?vue&type=script&lang=js"
export * from "./UserCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__